import { render, staticRenderFns } from "./CollectPaymentPanel.vue?vue&type=template&id=22ea2063&scoped=true"
import script from "./CollectPaymentPanel.vue?vue&type=script&lang=js"
export * from "./CollectPaymentPanel.vue?vue&type=script&lang=js"
import style0 from "./CollectPaymentPanel.vue?vue&type=style&index=0&id=22ea2063&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ea2063",
  null
  
)

export default component.exports